---
de:
  page_hits:
    admin:
      filters:
        all_time: Alle Zeiten
        custom: Benutzerdefiniert
        matching_referrer_page: Übereinstimmende Referrer-Seite
        user_logged_in: Benutzer angemeldet
        week_ago: Vor 1 Woche
      table:
        action: Aktion
        controller: Controller
        hit_count: Zugriffsanzahl
        percentage: Prozentsatz
      tabs:
        page_hits: Seitenzugriffe
        users: Benutzer
